// src/routes/AppRoutes.jsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Public Pages
import Homepage from '../Components/Home/HomePage';
import ContactPage from '../Components/Contact/contactpage';
import ServicesPage from '../Components/Services/servicePage';
import AboutPage from '../Components/About/AboutPage';
import PlatformFeatureDetail from '../Components/Platform/PlatformFeatureDetail';

// Auth Pages
import SignupPage from '../Components/Login_signup/signiup';
import LoginPage from '../Components/Login_signup/LOGIN/login';
import ForgotPasswordPage from '../Components/Login_signup/Forgotpass/Forgot_Password';
import ResetPasswordPage from '../Components/Login_signup/Forgotpass/Reset_Password';

// Student Pages
import StudentDashboard from '../Components/StudentDashboard/StudentDashboard';
import AllCollege from '../Components/CollegeDetails/allcolleges';
import CollegeSelectionApp from '../Components/Studentadmission/collegeselect';
import CollegeDetails from '../Components/CollegeDetails/CollegeDetails';
import Filter from '../Components/CollegeDetails/Filter';
import ProgramSelectionUI from '../Components/Studentadmission/ProgramSelectionUI';
import ScholarshipSelectionUI from '../Components/Studentadmission/ScholarshipUI';
import StudentApplicationForm from '../Components/StudentDashboard/StudentApplicationForm';
import CheckoutPage from '../Components/StudentDashboard/CheckoutPage';
import ApplicationConfirmation from '../Components/StudentDashboard/ApplicationConfirmation';

// Hero Route Pages
import CoachingPage from '../Components/Home/HeroRoute/CoachingPage';
import CounsellingPage from '../Components/Home/HeroRoute/CounsellingPage';
import Training from '../Components/Home/HeroRoute/Training';

// Dashboard Pages
import AgentDashboard from '../studentcounseling/AgentDashboard';
import InstitutionDashboard from '../studentcounseling/InstitutionDashboard';
import CounselorBookingDashboard from '../Components/Home/HeroRoute/StudentBookingsPage';


// ===================== COUNSELOR SYSTEM IMPORTS =====================
import CounselorRegistrationForm from '../studentcounseling/Counselor/CounselorRegistrationForm';
import CounselorDashboard from '../studentcounseling/Counselor/CounselorDashboard';
import PublicCounselorBooking from '../Components/Home/HeroRoute/CounsellingPage';
import StudentBookingsPage from '../Components/Home/HeroRoute/StudentBookingsPage';

// Protected Route Component
import ProtectedRoute from '../Components/Login_signup/LOGIN/ProtectedRoute';

// PublicForm
import PublicFormAccess from '../Components/Public/PublicFormAccess';

// Legal
import PrivacyPolicy from '../Components/Legal/PrivacyPolicy';
import RefundPolicy from '../Components/Legal/RefundPolicy';
import TermsAndConditions from '../Components/Legal/TermsAndConditions';

// College Dashboard
import CollegeDashboard from '../Components/CollegeDashboard/CollegeDashboard';

//FAQ
import FAQPage from '../Components/FAQ/faq';
//StudentCounselorBookingPage
//import StudentBookingsPage from '../Components/Home/HeroRoute/StudentBookingsPage'

//BLOGPOSTPAGE
import BlogPostPage from '../Components/Blog/BlogPostPage';
import BlogPage from '../Components/Blog/BlogPage';

import CounselorCheckoutPage from '../studentcounseling/Counselor/CounselorCheckoutPage';

export default function AppRoutes() {
  return (
    <Routes>

      {/* ===================== PUBLIC ROUTES ===================== */}
      <Route path="/" element={<Homepage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/services/counselling" element={<CounsellingPage />} />
      <Route path="/services/coaching" element={<CoachingPage />} />
      <Route path="/training" element={<Training />} />
     
      <Route path="/platform/:featureId" element={<PlatformFeatureDetail />} />
      
      {/* ===================== PUBLIC COUNSELOR ROUTES ===================== */}
      <Route path="/counseling/browse" element={<PublicCounselorBooking />} />
      <Route path="/counselors" element={<PublicCounselorBooking />} />
      <Route path="/counselors/:id" element={<PublicCounselorBooking />} />

      {/* Legal */}
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/refund-policy" element={<RefundPolicy />} />
      <Route path="/t&c" element={<TermsAndConditions />} />


      {/* Public form filling */}
      <Route path="/public-form" element={<PublicFormAccess />} />

      {/* ===================== AUTH ROUTES ===================== */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      {/* faq page */}
      <Route path='/faq' element={<FAQPage />} />

      {/* ===================== STUDENT PROTECTED ROUTES ===================== */}
      <Route 
        path="/student/dashboard" 
        element={
          <ProtectedRoute allowedUserTypes={['student']}>
            <StudentDashboard />
          </ProtectedRoute>
        } 
      />

<Route 
  path="/student/colleges" 
  element={<CollegeSelectionApp />} 
/>


      <Route 
        path="/student/programs" 
        element={
         
            <ProgramSelectionUI />
         
        } 
      />

      <Route 
        path="/student/scholarships" 
        element={
         
            <ScholarshipSelectionUI />
         
        } 
      />

      <Route 
        path="/student-form" 
        element={
          <ProtectedRoute allowedUserTypes={['student']}>
            <StudentApplicationForm />
          </ProtectedRoute>
        } 
      />

      <Route 
        path="/student/checkout" 
        element={
          <ProtectedRoute allowedUserTypes={['student']}>
            <CheckoutPage />
          </ProtectedRoute>
        } 
      />

      <Route 
        path="/application-confirmation/:appId" 
        element={
          <ProtectedRoute allowedUserTypes={['student']}>
            <ApplicationConfirmation />
          </ProtectedRoute>
        } 
      />
      <Route path='/blog' element={<BlogPage />} />
      <Route path='/blog/:slug' element={<BlogPostPage />} />

      {/* ===================== STUDENT COUNSELING BOOKING ROUTES ===================== */}
      <Route 
        path="/student/counseling" 
        element={
          <ProtectedRoute allowedUserTypes={['student']}>
            <CounsellingPage />
          </ProtectedRoute>
        } 
      />

      <Route 
        path="/student/bookings" 
        element={
          <ProtectedRoute allowedUserTypes={['student']}>
            <StudentBookingsPage />
          </ProtectedRoute>
        } 
      />
<Route 
  path="/counselor/checkout" 
  element={
    <ProtectedRoute allowedUserTypes={['partner', 'counselor']}>
      <CounselorCheckoutPage />
    </ProtectedRoute>
  } 
/>
      <Route 
        path="/student/my-bookings" 
        element={
          <ProtectedRoute allowedUserTypes={['student']}>
            <StudentBookingsPage />
          </ProtectedRoute>
        } 
      />

      <Route 
        path="/allcollege" 
        element={
          <ProtectedRoute allowedUserTypes={['student']}>
            <AllCollege />
          </ProtectedRoute>
        } 
      />

      <Route 
        path="/college/:idOrName" 
        element={
         
            <CollegeDetails />
         
        } 
      />

      <Route 
        path="/counseling" 
        element={
          <ProtectedRoute allowedUserTypes={['student']}>
            <CounsellingPage />
          </ProtectedRoute>
        } 
      />

      <Route 
        path="/coaching" 
        element={
          <ProtectedRoute allowedUserTypes={['student']}>
            <CoachingPage />
          </ProtectedRoute>
        } 
      />


      <Route 
        path="/training" 
        element={
          <ProtectedRoute allowedUserTypes={['student']}>
            <TrainingPage />
          </ProtectedRoute>
        } 
      />

      {/* ===================== COUNSELOR ROUTES ===================== */}
      {/* Counselor Registration - Accessible to partners who want to become counselors */}
      <Route 
        path="/counselor/register" 
        element={
          <ProtectedRoute allowedUserTypes={['partner', 'counselor']}>
            <CounselorRegistrationForm />
          </ProtectedRoute>
        } 
      />

      {/* 🔥 NEW: Counselor Booking Dashboard - For counselors who selected counseling */}
      <Route 
  path="/counselor/booking-dashboard" 
  element={
    <ProtectedRoute allowedUserTypes={['partner', 'counselor']}>
      <CounselorBookingDashboard />
    </ProtectedRoute>
  } 
/>

      {/* Counselor Dashboard - Main dashboard for counselors (legacy) */}
      <Route 
        path="/counselor/dashboard" 
        element={
          <ProtectedRoute allowedUserTypes={['partner', 'counselor']}>
            <CounselorDashboard />
          </ProtectedRoute>
        } 
      />

      {/* Counselor Profile Management */}
      <Route 
  path="/counselor/profile" 
  element={
    <ProtectedRoute allowedUserTypes={['partner', 'counselor']}>
      <CounselorDashboard />
    </ProtectedRoute>
  } 
/>

      {/* Counselor Bookings Management */}
      <Route 
  path="/counselor/bookings" 
  element={
    <ProtectedRoute allowedUserTypes={['partner', 'counselor']}>
      <CounselorBookingDashboard />
    </ProtectedRoute>
  } 
/>

      {/* Counselor Availability Settings */}
      <Route 
  path="/counselor/availability" 
  element={
    <ProtectedRoute allowedUserTypes={['partner', 'counselor']}>
      <CounselorBookingDashboard />
    </ProtectedRoute>
  } 
/>

      {/* ===================== AGENT ROUTES ===================== */}
      <Route 
        path="/agent/dashboard" 
        element={
          <ProtectedRoute allowedUserTypes={['partner']}>
            <AgentDashboard />
          </ProtectedRoute>
        } 
      />

      {/* ===================== INSTITUTION ROUTES ===================== */}
      <Route 
        path="/institution/dashboard" 
        element={
          <ProtectedRoute allowedUserTypes={['partner']}>
            <InstitutionDashboard />
          </ProtectedRoute>
        } 
      />

      {/* ===================== PARTNER ROUTES ===================== */}
      <Route 
        path="/partner/dashboard" 
        element={
          <ProtectedRoute allowedUserTypes={['partner']}>
            <PartnerDashboard />
          </ProtectedRoute>
        } 
      />

      {/* ===================== COLLEGE DASHBOARD ROUTE ===================== */}
      <Route 
        path="/college/dashboard" 
        element={
          <ProtectedRoute allowedUserTypes={['college']}>
            <CollegeDashboard />
          </ProtectedRoute>
        } 
      />

      {/* ===================== LEGACY ROUTES ===================== */}
      <Route path="/filter" element={<Filter />} />
      <Route path="/allcollegee" element={<Navigate to="/student/colleges" replace />} />

      {/* ===================== 404 NOT FOUND ===================== */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

// ===================== FALLBACK PAGES =====================
function PartnerDashboard() {
  return (
    <div className="min-h-screen bg-gray-100 p-6 pt-24">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">Partner Dashboard</h1>
        <div className="bg-white rounded-lg shadow-md p-6">
          <p className="text-gray-600 mb-4">Welcome to your partner dashboard!</p>
          <div className="space-y-3">
            <a 
              href="/counselor/register" 
              className="block px-6 py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition text-center"
            >
              Register as Counselor
            </a>
            <a 
              href="/counselor/booking-dashboard" 
              className="block px-6 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition text-center"
            >
              Go to Counselor Booking Dashboard
            </a>
            <a 
              href="/agent/dashboard" 
              className="block px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition text-center"
            >
              Go to Agent Dashboard
            </a>
            <a 
              href="/institution/dashboard" 
              className="block px-6 py-3 bg-cyan-600 text-white rounded-lg hover:bg-cyan-700 transition text-center"
            >
              Go to Institution Dashboard
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

function TrainingPage() {
  return (
    <div className="min-h-screen bg-gray-100 p-6 pt-24">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-800">Training Page</h1>
        <p className="text-gray-600 mt-4">Training resources coming soon...</p>
      </div>
    </div>
  );
}

function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-8">Page Not Found</p>
        <a 
          href="/" 
          className="px-6 py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition inline-block"
        >
          Go Back Home
        </a>
      </div>
    </div>
  );
}